import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RatingDisplay from '../Reviews/RatingDisplay';
import { withTranslation } from 'react-i18next';
import { productImpressionGA, productClickGA } from '../../js/analytics';

import { showActiveTripPopUp } from '../../actions/trip';

import {
  getPricePerPax,
  getPriceByPax,
  getDiscPricePerPax,
  createDiscountLabel,
  createPriceLabel,
  findMinMaxPaxRate
} from '../../js/utility';

import bookNowBg from '../../images/Book_Now.png';
import newLabelBg from '../../images/label_new.png';
import fullLabelBg from '../../images/label_fully_booked.png';
import emptyLeftLabelBg from '../../images/label_empty.png';
import emptyRightLabelBg from '../../images/Book_Now_No_Text.png';

const bookNowBgStyle = {
  background: `url(${bookNowBg}) no-repeat center/cover`
};

const fullLabelBgStyle = {
  background: `url(${fullLabelBg}) no-repeat center/cover`
};

const newLabelBgStyle = {
  background: `url(${newLabelBg}) no-repeat center/cover`
};

const emptyLeftLabelBgStyle = {
  background: `url(${emptyLeftLabelBg}) no-repeat center/cover`
};

const emptyRightLabelBgStyle = {
  background: `url(${emptyRightLabelBg}) no-repeat center/cover`
};

class NewTripItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDetails: false
    };
    this.convertDurationText = this.convertDurationText.bind(this);
    this.convertDate = this.convertDate.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  componentDidMount() {
    const { trip } = this.props;
    productImpressionGA(trip.id, trip.title, trip.vendor);
  }

  convertDate(date) {
    const month_names_short = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const day = date.substr(8, 2);
    const month = parseInt(date.substr(5, 2));
    const finalDate = day + ' ' + month_names_short[month-1];
    return finalDate;
  }

  convertDurationText(text) {
    if(text.search('hours') !== -1){
      text = text.replace('hours','HRS');
    }
    else if (text.search('Hours') !== -1){
      text = text.replace('Hours','HRS');
    }
    else if(text.search('hour') !== -1){
      text = text.replace('hour','HRS');
    }
    else if (text.search('Hour') !== -1){
      text = text.replace('Hour','HRS');
    }
    else if(text.search('minutes') !== -1){
      text = text.replace('minutes','MIN');
    }
    else if (text.search('Minutes') !== -1){
      text = text.replace('Minutes','MIN');
    }
    return text;
  }

  toggleDetails(){
    this.setState({isShowDetails: !(this.state.isShowDetails)});
  }

  render() {
    const { trip, showActiveTripPopUp, direct, showDuration, handleClick, startDate, t } = this.props;
    const isByAge = trip.trip_price.price_type === 'by_age'; // disabled in CMS
    const isPerTrip = trip.trip_price.is_per_trip; // disabled in CMS
    const isByPax = trip.trip_price.price_type === 'by_pax';
    let priceByPax = getPricePerPax(trip.trip_price);
    const pricePerPax = getPricePerPax(trip.trip_price, {
      pax_max: trip.pax_max
    });
    const discPricePerPax = getDiscPricePerPax(
      trip.trip_price,
      { pax_max: trip.pax_max },
      trip.trip_discount
    );

    // trip.image_cover.thumbnail_url = 'https://shop.sdacford.com.my/images/trips/ee64df6a-a953-44d3-9f18-9a8056741b58/zesjxq6hh.jpeg';

    const lowestAdultPax = findMinMaxPaxRate(trip.trip_price.adult_rate, 'min');

    // Include insurance, SST, & service fee
    const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
    const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
    const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;
    priceByPax.adult = priceByPax.adult + (insurance * lowestAdultPax);
    priceByPax.adult = priceByPax.adult + (priceByPax.adult * serviceFee);
    priceByPax.adult = priceByPax.adult + (priceByPax.adult * sstPercentage);

    let priceStr = createPriceLabel(priceByPax, discPricePerPax);
    let discountStr = createDiscountLabel(trip.trip_discount);

    if (trip.slug === 'ford-ranger-training-experience-sabah'){
      priceStr = 'From ' + priceStr.adult + ' per vehicle';
    }
    else if (trip.slug === 'off-roading-durian-adventure' || trip.slug === 'advanced-4wd-adventure-off-road-course-at-m4trec-morning-session'){
      priceStr = priceStr.adult + ' (1 pax)';
    }
    else if (trip.slug === 'a-trip-through-nature-at-gunung-jerai'){
      priceStr = 'From ' + priceStr.adult + '<br> (Up to 4 pax)';
    }
    else if (isPerTrip) {
      priceStr = t('gen:pricePerTrip', {
        price: priceStr
      });
    } else if (isByAge) {
      priceStr = t('gen:fromPricePerPax', {
        price: priceStr.adult
      }).concat('**');
    } else if (isByPax) {
      priceStr = t('gen:fromPriceByPax', {
        price: priceStr.adult,
        minPax: trip.pax_min
      });
    } else {
      priceStr = t(
        `gen:${trip.pax_min > 1 ? 'fromPricePerPax' : 'pricePerPax'}`,
        {
          price: priceStr
        }
      ).concat(trip.pax_min > 1 ? '*' : '');
    }

    return (
      <div className='trip-item'>
        <div className='fe-trip-item-info-main'>
          {discountStr ? (
            <div className='fe-discount-label'>
              {t('gen:discountOff', { discountAmount: discountStr })}
            </div>
          ) : null}
          {/* {trip.byor ? (
            <div className='trip-item-byoc-icon'>
              <img src={iconBYOC} alt='' />
            </div>
          ) : null} */}
          {/* {(trip.upcoming)? (
            <div className='trip-item-50-off text-coming-soon'>
              <div className='trip-item-50-off-text'>
              COMING SOON
              </div>
            </div>
          ) : null} */}
          {trip.slug === 'ford-ranger-training-experience-sabah' || trip.slug === 'ford-ranger-training-experience' ? (
            // <div className='trip-item-50-off'>
            //   {/* <img src={bookIcon} alt='' /> */}
            //   <div className='trip-item-50-off-text'>
            //     50%
            //   </div>
            //   <div className='trip-item-50-off-text'>
            //     OFF
            //   </div>
            // </div>
            null
          ) : null}
          <div
            className={`trip-item-link ${!direct ? 'mobile-only' : ''}`}
          >
            <div
              className={`fe-u-thumb-long fe-rounded ${(this.state.isShowDetails)? 'show-details' : ''}`}
              style={{background: `url(${trip.image_cover.thumbnail_url}) no-repeat center/cover`}}
              onClick={this.toggleDetails}>

              <div className='fe-item-details'>
                {
                  (trip.fully_book) ? (
                    <div className='fe-item-full-label' style={fullLabelBgStyle}>
                    </div>
                  ):(
                    (trip.is_new_label)
                      ? (
                        <div className='fe-item-new-label' style={newLabelBgStyle}>
                        </div>
                      ) : (
                    // (trip.upcoming) ? (
                    //   <div className='fe-item-empty-label' style={emptyLeftLabelBgStyle}>
                    //     COMING SOON
                    //   </div>
                    // ) :
                        null)
                  )
                }
                <div className='fe-item-details-top'>
                  { (trip.slug === 'sunrise-cameron-highlands') ?
                    (
                      <Link className='fe-item-right-empty-label'
                        onClick={() => {productClickGA(trip.id, trip.title, trip.vendor); handleClick;}}
                        to={`/trips/${trip.slug}`}
                        style={emptyRightLabelBgStyle}
                      >
                        PAST EXPERIENCE
                      </Link>
                    ) : (
                      (trip.upcoming) ?
                        (
                          <Link className='fe-item-right-empty-label'
                            onClick={() => {productClickGA(trip.id, trip.title, trip.vendor); handleClick;}}
                            to={`/trips/${trip.slug}`}
                            style={emptyRightLabelBgStyle}
                          >
                            COMING SOON
                          </Link>
                        ) : (
                          (trip.fully_book) ? (
                            <Link className='fe-item-right-empty-label'
                              onClick={() => {productClickGA(trip.id, trip.title, trip.vendor); handleClick;}}
                              to={`/trips/${trip.slug}`}
                              style={emptyRightLabelBgStyle}
                            >
                              FULLY BOOKED
                            </Link>
                          ) : (
                            <Link className='fe-item-book-now'
                              onClick={() => {productClickGA(trip.id, trip.title, trip.vendor); handleClick;}}
                              to={`/trips/${trip.slug}`}
                              style={bookNowBgStyle}
                            >
                            </Link>
                          )
                        )
                    )
                  }
                </div>
                <div className='fe-item-details-bottom'>
                  <h3 className='trip-item-title'>
                    {trip.title}
                  </h3>
                  <div className='trip-item-additional-detail'>
                    <span className='trip-item-loc'>{trip.location_text}</span>
                    <div className={`trip-item-capsule ${(startDate) ? '' : 'no-date'}`}>
                      <div className='trip-item-duration'>
                        <span className='trip-item-duration-span'>
                          {this.convertDurationText(trip.duration)}
                        </span>
                      </div>
                      {(startDate) ? (
                        <div className='trip-item-date'>
                          <span className='trip-item-date-span'>
                            {this.convertDate(startDate)}
                          </span>
                        </div> ): null}
                    </div>
                    <div
                      className='trip-item-price'
                      dangerouslySetInnerHTML={{
                        __html: trip.slug !== 'ford-ranger-training-experience-sabah' || !trip.upcoming ? (priceStr): null
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {direct ? null : (
            <div
              onClick={() => {showActiveTripPopUp(trip.id, true); handleClick();}}
              className='fe-u-thumb-long fe-rounded desktop-only'
              style={{background: `url(${trip.image_cover.thumbnail_url}) no-repeat center/cover`}}>

              <div className='fe-item-details'>
                {
                  (trip.fully_book) ? (
                    <div className='fe-item-full-label' style={fullLabelBgStyle}>
                    </div>
                  ):(
                    (trip.is_new_label)
                      ? (
                        <div className='fe-item-new-label' style={newLabelBgStyle}>
                        </div>
                      ) : (
                    // (trip.upcoming) ? (
                    //   <div className='fe-item-empty-label' style={emptyLeftLabelBgStyle}>
                    //     COMING SOON
                    //   </div>
                    // ) :
                        null)
                  )
                }

                <div className='fe-item-details-top'>
                  { (trip.slug === 'sunrise-cameron-highlands') ? (
                    <div className='fe-item-right-empty-label' style={emptyRightLabelBgStyle}>
                      PAST EXPERIENCE
                    </div>
                  ) : (
                    (trip.upcoming) ?
                      (
                        <div className='fe-item-right-empty-label' style={emptyRightLabelBgStyle}>
                          COMING SOON
                        </div>
                      ) : (
                        (trip.fully_book) ? (
                          <div className='fe-item-right-empty-label' style={emptyRightLabelBgStyle}>
                            FULLY BOOKED
                          </div>
                        ) : (
                          <div className='fe-item-book-now' style={bookNowBgStyle}>
                          </div>
                        )
                      )
                  )
                  }
                </div>
                <div className='fe-item-details-bottom'>
                  <h3 className='trip-item-title desktop-only'>
                    {trip.title}
                  </h3>
                  <div className='trip-item-additional-detail'>
                    <span className='trip-item-loc'>{trip.location_text}</span>
                    <div className={`trip-item-capsule ${(startDate) ? '' : 'no-date'}`}>
                      <div className='trip-item-duration'>
                        <span className='trip-item-duration-span'>
                          {this.convertDurationText(trip.duration)}
                        </span>
                      </div>
                      {(startDate) ? (
                        <div className='trip-item-date'>
                          <span className='trip-item-date-span'>
                            {this.convertDate(startDate)}
                          </span>
                        </div> ): null}
                    </div>
                    <div
                      className='trip-item-price'
                      dangerouslySetInnerHTML={{
                        __html: trip.slug !== 'ford-ranger-training-experience-sabah' || !trip.upcoming ? (priceStr): null
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* <div className='trip-item-info'>

            {showDuration ? (
              <span className='trip-item-duration'>{trip.duration}</span>
            ) : null}
          </div> */}
          {/* <Link
            onClick={() => productClickGA(trip.id, trip.title, trip.vendor)}
            to={`/trips/${trip.slug}`}
            className={`trip-item-link ${!direct ? 'mobile-only' : ''}`}
          >
            <h3 className='trip-item-title'>{trip.title}</h3>
          </Link> */}
          {/* {direct ? null : (
            <h3
              className='trip-item-title desktop-only'
              onClick={() => {showActiveTripPopUp(trip.id, true); handleClick();}}
            >
              {trip.title}
            </h3>
          )} */}
        </div>
        {/* <div className='fe-trip-item-btm'>
          <RatingDisplay
            rating={trip.rating}
            showTotal
            totalRatings={trip.reviews}
          />
        </div> */}
      </div>
    );
  }
}

NewTripItem.propTypes = {
  trip: PropTypes.object.isRequired,
  showActiveTripPopUp: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  direct: PropTypes.bool.isRequired,
  showDuration: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

NewTripItem.defaultProps = {
  direct: false,
  showDuration: true
};

const mapDispatchToProps = {
  showActiveTripPopUp
};

export default withTranslation()(
  connect(
    null,
    mapDispatchToProps
  )(NewTripItem)
);
